import React from 'react';
import {FormControl, Input, InputLabel} from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";

interface UploadLegalAgreementProps {
  handleFileUpload: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  error?: boolean;
  helperText?: string;
}

const UploadLegalAgreement = (props: UploadLegalAgreementProps) => {
  const {handleFileUpload, error, helperText} = props;

  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel htmlFor={'ssLegalAgreement'} variant={'standard'} color={'primary'} shrink={true}>Legal Agreement</InputLabel>
      <Input
        id='ssLegalAgreement'
        type={'file'}
        onChange={handleFileUpload}
        error={error}
      />
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </FormControl>
  )
}

export default UploadLegalAgreement;
